const FIELD_ERROR_SELECTOR = '.Mui-error, [data-field-error="true"]';

export const scrollToFirstError = () => {
    setTimeout(() => {
        const firstError = document.querySelector(FIELD_ERROR_SELECTOR);
        firstError?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 0);
};
